module.exports = __webpack_public_path__ + "img/wind-turbine.e9851ba4.svg";